module.exports = __webpack_public_path__ + "img/Annotations_2.424f2237.jpg";